import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    confirm: String
  }

  static targets = ["message"]

  async clearAll(event) {
    event.preventDefault()

    if (this.hasConfirmValue && !window.confirm(this.confirmValue)) {
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        this.showMessage("Failed to clear cache. Please try again.", "error")
      }
    } catch (error) {
      console.error("Cache clear error:", error)
      this.showMessage("An error occurred while clearing cache.", "error")
    }
  }

  async warmCache(event) {
    event.preventDefault()

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        this.showMessage("Failed to start cache warming. Please try again.", "error")
      }
    } catch (error) {
      console.error("Cache warm error:", error)
      this.showMessage("An error occurred while starting cache warming.", "error")
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  showMessage(text, type = "info") {
    if (this.hasMessageTarget) {
      const alertClass = type === "error"
        ? "bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-300"
        : "bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-300"

      this.messageTarget.innerHTML = `
        <div class="rounded-md p-4 ${alertClass} border">
          <p class="text-sm font-medium">${text}</p>
        </div>
      `

      setTimeout(() => {
        if (this.hasMessageTarget) {
          this.messageTarget.innerHTML = ""
        }
      }, 5000)
    }
  }
}